@if (scan() != null) {
  <onyx-upload
    [value]="scan()"
    [disabled]="true"
    [hideBorder]="true"
    [size]="32"
  ></onyx-upload>
} @else {
  <span>{{ 'labels.noFile' | translate }}</span>
}
